import { NgModule } from '@angular/core';
import { ImageDataUrlPipe } from './image-data-url.pipe';
import { ImageSrcDirective } from './image-src.directive';
import { ImageSrcService } from './image-src.service';
import { AppImageUrlPipe } from './image-url.pipe';

@NgModule({
  imports: [],
  exports: [
    ImageSrcDirective,
    ImageDataUrlPipe,
    AppImageUrlPipe
  ],
  declarations: [
    ImageSrcDirective,
    ImageDataUrlPipe,
    AppImageUrlPipe
  ],
  providers: [
    ImageSrcService,
  ],
})
export class ImageModule {}
